import { useCallback, useEffect, useRef } from 'react';
import { DOM_EVENTS } from '../constants/navigationConstants';
import { DATA_ATTRIBUTES } from '../constants/navigationConstants';

/**
 * Custom hook to manage focus and blur events for navigation containers
 * Handles complex focus logic for accessibility
 */
export const useNavigationFocus = (setOpenCategory) => {
    const containerRef = useRef(null);

    const handleContainerBlur = useCallback((e) => {
        const relatedTarget = e.relatedTarget;
        const isWithinContainer = containerRef.current?.contains(relatedTarget);
        const isServiceCard = relatedTarget?.closest(DATA_ATTRIBUTES.SERVICE_CARD);
        const isCategoryButton = relatedTarget?.closest(DATA_ATTRIBUTES.NAV_CATEGORY);

        if (!isWithinContainer && !isServiceCard && !isCategoryButton) {
            setOpenCategory(null);
        }
    }, [setOpenCategory]);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const handleFocusOut = (e) => {
            const relatedTarget = e.relatedTarget;
            const isWithinContainer = container.contains(relatedTarget);
            const isServiceCard = relatedTarget?.closest(DATA_ATTRIBUTES.SERVICE_CARD);
            const isCategoryButton = relatedTarget?.closest(DATA_ATTRIBUTES.NAV_CATEGORY);
            
            if (!isWithinContainer && !isServiceCard && !isCategoryButton) {
                setOpenCategory(null);
            }
        };

        container.addEventListener(DOM_EVENTS.FOCUS_OUT, handleFocusOut);
        return () => container.removeEventListener(DOM_EVENTS.FOCUS_OUT, handleFocusOut);
    }, [setOpenCategory]);

    return { containerRef, handleContainerBlur };
};
